/**
 * Address Service
 * Register Angular Services for all things Address
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Address', ['$resource', function($resource){
    return $resource('/api/v2/address/:id');
}]);
